import { render, staticRenderFns } from "./TabNotifications.vue?vue&type=template&id=5e2445c0&"
import script from "./TabNotifications.vue?vue&type=script&lang=js&"
export * from "./TabNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TabNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports